import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../../reducers";
import { gigyaLogin, gigyaJoin } from "../../actions/auth";
import Instructions from "./Instructions";
import WofButton from "../WofButton";
import TileInput from "./TileInput";
import findLastIndex from "lodash/findLastIndex";
import { BonusPuzzleType, BonusPuzzleStatus } from "../../types";
import { postBonusPuzzleResult } from "../../api/cms";
import { bonusPuzzleIds } from "../../analyticsTags";
import "./styles.scss";
import BonusPuzzleModal from "./Modals/BonusPuzzleModal";
import LoginModal from "./Modals/LoginModal";

const arrayToString = (ar: string[]): string => {
  return ar
    .map(letter => {
      if (letter === "'" || letter === "‘" || letter === "’" || letter === "\'") {
        return "'";
      }
      return letter;
    })
    .join("")
    .toLowerCase();
};
const hasSolved = (solution: string[], attempt: string[]) => {
  return arrayToString(solution) === arrayToString(attempt);
};

const BonusPuzzle: React.FC<BonusPuzzleType> = (props) => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [letters, setLetters] = useState<string[]>([]);
  const [origLetters, setOrigLetters] = useState<string[]>([]);
  const [first, setFirst] = useState<number>(-1);
  const [last, setLast] = useState<number>(-1);
  const [current, setCurrent] = useState<number>(-1);
  const [winStatus, setWinStatus] = useState<BonusPuzzleStatus>("none");
  const [isGameOver, setGameOver] = useState(false);

  useEffect(() => {
      if (
        winStatus === "none" &&
        props.isLoggedIn && props.solution !== undefined &&
        props.solution.length === 52
      ) {
        let chars = props.solution.split("");
        chars.splice(52, 0, "/");
        chars.splice(40, 0, "/");
        chars.splice(12, 0, "/");
        chars.splice(0, 0, "/");

        let currFirst = chars.findIndex((c) => c !== "/");
        let currLast = findLastIndex(chars, (c: string) => c !== "/");
        setFirst(currFirst);
        setLast(currLast);
        setOrigLetters(chars);
        setLetters(
          chars.map((currChar, i) => {
            const empty = currChar !== "/" && currFirst !== i && currLast !== i;
            return empty ? "" : currChar;
          })
        );
        setWinStatus("inprogress");
      } else if (!props.isLoggedIn) {
        setFirst(-1);
        setLast(-1);
        setCurrent(-1);
        setOrigLetters([]);
        setLetters([]);
        setWinStatus("none");
      }
  }, [props.solution, props.isLoggedIn, winStatus]);


  const handleChange = (value: string, i: number) => {
    const newLetters = [...letters];
    newLetters[i] = value;
    setLetters(newLetters);
    if (value !== "") {
      onForward(i);
    }
  };

  const onForward = (curr: number) => {
    let nextIndex = curr + 1 > last ? first : curr + 1;

    while (origLetters[nextIndex] === "/" && nextIndex < last) {
      nextIndex++;
    }

    return setCurrent(nextIndex);
  };

  const onBack = (curr: number) => {
    let nextIndex = curr - 1 < first ? last : curr - 1;

    while (origLetters[nextIndex] === "/" && nextIndex > first) {
      nextIndex--;
    }

    return setCurrent(nextIndex);
  };

  const checkWinStatus = () => {
    const status = hasSolved(origLetters, letters) ? "won" : "lost";
    setWinStatus(status);
  };

  const startOver = () => {
    setWinStatus("none");
    setGameOver(false);
    setCurrent(first);
  };

  const InstructionsData = {
    Title1: props.learnToPlayTitle1,
    Title2: props.learnToPlayTitle2,
    Alt1: props.learnToPlayAlt1,
    Alt2: props.learnToPlayAlt2,
    Description1: props.learnToPlayDescription1,
    Description2: props.learnToPlayDescription2,
    Image1: props.learnToPlayImage1,
    Image2: props.learnToPlayImage2,
  };

  return (
    <div className="bonus-puzzle-container">
      {
        <style
          dangerouslySetInnerHTML={{
            __html: `
      .bonus-puzzle-container{
          background-image: url("${props.background}")
        }
      @media (min-width: 320px) and (max-width: 767px) {
        .bonus-puzzle-container{
          background-image: url("${props.mobilebackground}")
        }`,
          }}
        />
      }

      <Instructions
        onClose={() => setShowInstructions(false)}
        show={showInstructions}
        instructionsData={InstructionsData}
      />
      <BonusPuzzleModal
        show={winStatus === "won" && !isGameOver}
        title={props.winTitle}
        description={props.winDescription}
        onHide={() => setGameOver(true)}
        onClose={() => setGameOver(true)}
      />
      <BonusPuzzleModal
        show={winStatus === "lost" && !isGameOver}
        title={props.loseTitle}
        description={props.loseDescription}
        onHide={() => setGameOver(true)}
        onClose={startOver}
        btnCloseText={props.startOverLbl}
      />
      <h1 className="bonus-puzzle-title">{props.title}</h1>
      <div
        className="bonus-puzzle-aired"
        style={props.airedonFontColor ? {color: props.airedonFontColor} : {}}
      >
        Aired on: {props.date}
      </div>
      {props.presentedByLbl && props.presentedByLogo ? (
        <div
          className="bonus-puzzle-aired bonus-presentedby"
          style={
            props.presentedByFontColor
              ? {color: props.presentedByFontColor}
              : {}
          }
        >
          {props.presentedByLbl} : <img alt={"logo"}
                                        src={props.presentedByLogo}/>
        </div>
      ) : null}
      <div className="board-container">
        <div className="board-aspect">
          <div className="board-wrapper">
            {props.loginStatusChecked && (
              <LoginModal
                isLoggedIn={props.isLoggedIn}
                onLogIn={props.onLogIn}
                onJoin={props.onJoin}
                loginStatusChecked={props.loginStatusChecked}
              />
            )}
            <form className={`board${isGameOver ? " game_over" : ""}`}>
              {letters.map((letter, i) => {
                const isHidden = letter === "/";
                const readOnly = !isHidden && (i === first || i === last);
                let imageName = letter.toLowerCase();

                if (letter == " ") {
                  imageName = "space";
                } else if (letter == ":") {
                  imageName = "colon";
                } else if (letter == '"') {
                  imageName = "doubleQuote";
                } else if (letter == "!") {
                  imageName = "exclaim";
                } else if (letter == "'" || letter == "‘" || letter == "’" || letter == "\'") {
                  imageName = "apos";
                } else if (letter == "&") {
                  imageName = "and";
                } else if (letter == ".") {
                  imageName = "period";
                } else if (letter == "-") {
                  imageName = "dash";
                } else if (letter == "?") {
                  imageName = "questionMark";
                } else if (letter == "\\") {
                  imageName = "backslash";
                } else if (letter == "|") {
                  imageName = "pipe";
                } else if (letter == ">") {
                  imageName = "great";
                } else if (letter == "<") {
                  imageName = "small";
                } else if (letter == "*") {
                  imageName = "star";
                }
                return (
                  <span
                    key={`letters_${i}`}
                    className={`slot${isHidden ? "" : " visibleslot"}`}
                  >
                    {!isHidden && (
                      <div>
                        {letter && (
                          <div className="imagediv">
                            <img
                              className="image"
                              src={require(`./images/letters/${imageName}.jpg`)}
                              alt={letter}
                            />
                          </div>
                        )}
                        <TileInput
                          focused={current === i}
                          letter={readOnly ? letter : undefined}
                          readOnly={readOnly}
                          onBack={() => onBack(i)}
                          onSetFocus={() => setCurrent(i)}
                          onForward={() => onForward(i)}
                          onChange={(v: string) => handleChange(v, i)}
                          onSumbit={checkWinStatus}
                        />
                      </div>
                    )}
                  </span>
                );
              })}
            </form>
          </div>
        </div>
      </div>

      <div className="bonus-puzzle-cat-bar">
        <span className="hint">{props.hint}</span>
      </div>
      <div className="bonus-puzzle-cat-shadow"/>
      <div className="bonus-puzzle-buttons">
        {/** options primary = white, blue, purple, hover = lighter blue. secondary = yellow, hover = orange */}
        <WofButton
          disabled={!props.isLoggedIn}
          vType="light"
          baseColor={props.startOverBasecolor}
          hoverColor={props.startOverHovercolor}
          labelColor={props.startOverFontcolor}
          labelHoverColor={props.startOverTextHovercolor}
          onClick={startOver}
        >
          {props.startOverLbl}
        </WofButton>
        <WofButton
          baseColor={props.submitBaseColor}
          hoverColor={props.submitHoverColor}
          labelColor={props.submitTextColor}
          labelHoverColor={props.submitTextHoverColor}
          disabled={!props.isLoggedIn || winStatus === "won"}
          onClick={checkWinStatus}
          id={bonusPuzzleIds.bonusPuzzleSubmit}
        >
          {props.submitLbl}
        </WofButton>
      </div>
      <div className="bonus-puzzle-learn-to-play">
        {/*<WofButton

        labelColor={props.learnToPlayTextColor}
          id={bonusPuzzleIds.bonusPuzzleShowInstructions}
          displayType="link"
          vType={props.learnToPlayClass}
          onClick={() => setShowInstructions(true)}>
          {props.learnToPlayLbl}
        </WofButton>*/}
        {props.learnToPlayHoverColor ? (
          <style
            dangerouslySetInnerHTML={{
              __html:
                `.ClickLearn:hover { color: ` +
                props.learnToPlayHoverColor +
                ` !important; } `,
            }}
          />
        ) : null}
        <a
          className={"ClickLearn"}
          style={{color: props.learnToPlayTextColor}}
          href="/"
          onClick={(e) => {
            e.preventDefault();
            setShowInstructions(true);
          }}
        >
          {props.learnToPlayLbl}
        </a>
      </div>
      <div className="bonus-puzzle-time-copy">
        <span className="bonus-puzzle-time-copy-text">
          You can play the Bonus Puzzle each weekday starting at 3:00 PM PT.<br/>
          If you do not see the correct date, please try clearing your cache and cookies.
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state.auth.isLoggedIn,
  loginStatusChecked: state.auth.loginStatusChecked,
});

const mapDispatchToProps = (dispatch: any) => ({
  onLogIn: () => dispatch(gigyaLogin()),
  onJoin: () => dispatch(gigyaJoin()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BonusPuzzle);
